import * as React from 'react';
import { LogoImage } from '../BrandImages';
import { FlexRow } from '../FlexRow';
import { HeaderShadowWrapper } from '../HeaderShadowWrapper';
import { NavigationItem } from '../Navigation/NavigationItem';
import { ButtonDropdown } from '../ButtonDropdown';
import { TDropdownElementProps } from '../Dropdown';
import { HeaderPaddingWrapper } from './Header.styles';
import { SearchBar } from 'components/shared/SearchBar/SearchBar';
import { LogOutNavigationItem } from '../../../components/userProfile/LogOutNavigationItem';
import { useHasFeatureFlag } from '../../../selectors/useHasFeatureFlag';

interface IHeaderProps {
  /** A callback fired when the "logo" is clicked. */
  onHomeClick?: () => void;
  actionItems?: TDropdownElementProps[];
  logoLink?: string;
  notification?: React.ReactNode;
  profile?: React.ReactNode;
  showAuthenticatedControls?: boolean;
  children?: React.ReactNode;
}

export const Header: React.FC<IHeaderProps> = ({
  onHomeClick,
  actionItems,
  children,
  logoLink,
  notification,
  profile,
  showAuthenticatedControls,
}) => {
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');

  return (
    <HeaderShadowWrapper useDefaultBackground={isZillowClosingEnabled}>
      <HeaderPaddingWrapper>
        <FlexRow justifyContent={'space-between'}>
          <FlexRow verticalAlign={'center'}>
            <NavigationItem text={'Logo'} onClick={onHomeClick} to={logoLink}>
              <LogoImage />
            </NavigationItem>
            {children}
          </FlexRow>
          <SearchBar />
          <FlexRow verticalAlign={'center'}>
            {showAuthenticatedControls ? (
              <>
                {!!actionItems && (
                  <ButtonDropdown intent={'primary'} items={actionItems} data-test-id={`global-navigation-actions`} />
                )}
                {notification}
                {profile ? profile : <LogOutNavigationItem />}
              </>
            ) : null}
          </FlexRow>
        </FlexRow>
      </HeaderPaddingWrapper>
    </HeaderShadowWrapper>
  );
};
